<div
  id="sodexo-portal-link"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          MobilisePortal's
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="row text-center">
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/ingenium.png" width="40" />
              <h4>Launch Ingenium</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/env.png" width="40" />
              <h4>eNOVhub</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/workplace-min.png" width="40" />
              <h4>MobiliseWorkPlace</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/safety-min.png" width="40" />
              <h4>Safety Walk</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/office_365.png" width="40" />
              <h4>Mobilise365</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/outlook.png" width="40" />
              <h4>Outlook</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/intranet.png" width="40" />
              <h4>MobiliseIntranet</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/yammer.png" width="40" />
              <h4>Yammer</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/linkdin.png" width="40" />
              <h4>Linkedin</h4>
            </a>
          </div>
          <div class="col-4">
            <a
              href="#"
              target="_blank"
            >
              <img src="./assets/img/quick/fb.png" width="40" />
              <h4>Facebook</h4>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
